import { render, staticRenderFns } from "./CondPrivacy.vue?vue&type=template&id=0d2daed2&scoped=true"
import script from "./CondPrivacy.vue?vue&type=script&lang=js"
export * from "./CondPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2daed2",
  null
  
)

export default component.exports